import { gql } from 'urql';

const FetchHelpAndSupportPageTile = gql`
  query FetchHelpAndSupportPageTile {
    helpAndSupportPageTiles(
      input: {
        tileType: [
          ALERT_BANNER
          MY_VARO
          POPULAR_TOPICS_TILE
          SURVEY_TILE
          DISPUTES
        ]
        myVaroTileType: [CONTACT_US]
        surveyTileType: [POST_CHAT]
      }
    ) {
      id
      status
      tileType
      ... on HelpAndSupportPageTiles {
        id
        status
        tileType
        tiles {
          id
          status
          tileType
          ... on MyVaroTile {
            title
            subtitle
            url
          }
          ... on BannerMessageTile {
            id
            tileType
            status
            banners {
              ... on AlertBannerMessage {
                id
                type
                message
              }
              __typename
            }
          }
          ... on PopularTopicsTile {
            id
            tileId
            status
            title
            tileType
            subTitle
            subTitleUrl
            popularTopics {
              id
              articleId
              title
              url
              onClickAnalytics {
                __typename
                name
                properties {
                  __typename
                  key
                  value
                }
              }
            }
          }
          ... on DisputesTile {
            id
            tileId
            status
            tileType
            processSteps {
              title
              message
              isComplete
            }
          }
        }
      }
    }
  }
`;

export default FetchHelpAndSupportPageTile;
